<template>
  <div class="resume-from-email d-flex justify-content-center align-items-center">
    <Loader :loader-text="loaderText" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loader from '@/components/common/Loader.vue'
import { showSuccessMessage, showErrorMessage } from '@/notification-utils'

export default {
  name: 'ResumeBuyerCampaignFromEmail',

  components: {
    Loader
  },

  props: {
    accountId: {
      type: String,
      required: true
    },

    campaignId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loaderText: 'Resuming your campaign...'
    }
  },

  async created() {
    try {
      await this.resumeBuyerCampaignByAccount({
        accountId: this.accountId,
        campaignId: this.campaignId
      })

      showSuccessMessage('Campaign resumed successfully')
    } catch (error) {
      const errorTitle = error?.response?.data?.title

      if (errorTitle === 'Campaign is already in the requested state') {
        showErrorMessage('Campaign is already active')
      } else {
        showErrorMessage('Could not resume the campaign. Please try again.')
      }
    } finally {
      this.$router.replace({
        name: 'BuyerEditCampaign',
        params: { id: this.campaignId }
      })
    }
  },

  methods: {
    ...mapActions('campaign', ['resumeBuyerCampaignByAccount'])
  }
}
</script>

<style lang="scss" scoped>
.resume-from-email {
  min-height: 50vh;
}
</style>
